export default __webpack_public_path__ + "static/open-browser-49bc6951e893bc14d60b4e17b7bec48c.png";